import { makeRequest } from "./index";

export async function getAccreditations(filters) {
  return await makeRequest("GET", "eletive_accreditations", null, filters);
}

export async function getAccreditationDetails(id) {
  return await makeRequest("GET", `eletive_accreditations/${id}`);
}

export async function getAccreditationType() {
  return await makeRequest("GET", "eletive_types");
}

export async function saveAccreditation(data, id, isUpdt) {
  const method = !isUpdt ? "POST" : "PUT";
  const route = !isUpdt
    ? "eletive_accreditations"
    : `eletive_accreditations/${id}`;

  return await makeRequest(method, route, data);
}

export async function saveBindAccreditationProcedure(data, id, isUpdt) {
  const method = !isUpdt ? "POST" : "PUT";
  const route = !isUpdt
    ? "eletive_accreditation_procedures"
    : `eletive_accreditation_procedures/${id}`;

  return await makeRequest(method, route, data);
}

export async function getBindedProcedures(filters) {
  return await makeRequest("GET", "procedure_surgery_eletives", null, filters);
}

export async function saveBindedProcedure(data, id, isUpdt) {
  const method = !isUpdt ? "POST" : "PUT";
  const route = !isUpdt
    ? "procedure_surgery_eletives"
    : `procedure_surgery_eletives/${id}`;

  return await makeRequest(method, route, data);
}

export async function getProceduresUnifield() {
  return await makeRequest(
    "GET",
    "group_eletive_surgeries/procedures_unifield"
  );
}

export async function getAccreditationFlagTypes() {
  return await makeRequest("GET", "type_financings");
}
